<template>
    <transition name="fade2">
    <div v-if="show" class="relative dark:border-gray-700 border dark:bg-gray-800 bg-gray-100 text-gray-800 dark:text-gray-200 shadow-lg rounded-lg h-auto mb-2" role="alert">
        <div class="absolute left-full -ml-4">
            <span @click.prevent="close()" aria-hidden="true" class="cursor-pointer">&times;</span>
        </div>
        <div class="flex px-4 py-2 flex-row items-center h-full gap-x-8">
            <div class="h-full  flex items-center">
                <span v-if="notification.type === 'success'" class="text-3xl material-icons-outlined select-none text-green-400">
                    check_circle
                </span>
                <span v-else-if="notification.type === 'error'" class="text-3xl material-icons-outlined select-none text-red-600">
                    error_outline
                </span>
                <span v-else class="text-3xl material-icons-outlined select-none text-yellow-500">
                    warning_amber
                </span>
            </div>
            <div class=" flex-1 ">
                <ul v-if="notification.type === 'error'" >
                    <ul v-for="msg in notification.message" :key="msg">
                        <li class="text-sm" v-for="m in msg" :key="m">{{m}}</li>
                    </ul>
                </ul>
                <span v-else>
                    <p :class="notification.type === 'success' ? 'dark:text-green-50 text-green-300' : notification.type === 'error' ? 'dark:text-red-50 text-red-500' : 'dark:text-yellow-50 text-yellow-400' " 
                    class="w-full mt-1 break-words">{{notification.message}}</p>
                </span>
            </div>
        </div>
    </div>
    </transition>
</template>

<script>
import { useStore } from 'vuex'
import { onBeforeUnmount } from 'vue'
export default {
    props: ['notification', 'show'],
    setup(props) {
        const store = useStore()
        const close = () => {
            props.show = !props.show
            store.dispatch('notify/removeNotification', props.notification)
        }

        const timeout = setTimeout(() => {
            props.show = !props.show
            store.dispatch('notify/removeNotification', props.notification)
        }, 5000)

        onBeforeUnmount(() => {
            clearTimeout(timeout)
        })
        return  {
            close
        }

    }

}
</script>

<style>
.fade2-enter-from {
  opacity: 0;
}
.fade2-enter-to {
  opacity: 1;
}

.fade2-enter-active {
  transition: all 1s ease-in-out;
}

.fade2-leave-active {
  transition: all 1s ease-in-out;
}

.fade2-leave-from {
  opacity: 1;
}

.fade2-leave-to {
  opacity: 0;
}


</style>